module.exports = __webpack_public_path__ + "img/pharmeyes_logo.47cb773b.png";